const resources = {
    via: 'par'
};

export default function getResource(label) {
    return resources[label];
}
